import React from 'react';

export default function PennylaneErrorMessage({ errorData }) {
    return <p>{errorData?.details ?? errorData?.title}</p>;
}
